import { type OfferV11 } from '@redteclab/api/clients/bully'

import { productAccessorGetBestSellerPromotionFromOffer } from '../../../product'

export const productAccessorOfferHasSellerPromotion = (
  offer: OfferV11 | undefined,
): boolean => Boolean(productAccessorGetBestSellerPromotionFromOffer(offer))
